import React, { useCallback, useContext, useState, useEffect } from 'react';
import _ from 'lodash';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import { InputField, CheckboxField, DropdownSelectField, IconButton, ModalNextProvider } from '@jutro/components';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { TranslatorContext } from '@jutro/locale';
import {ViewModelServiceContext} from 'gw-portals-viewmodel-react'
import { WizardPage, wizardProps } from 'gw-portals-wizard-react';
import { useDependencies } from 'gw-portals-dependency-react';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { useValidation } from 'gw-portals-validation-react';
import { messages as paymentMessages } from 'gw-capability-policychange-common-react';
import wizardConfig from '../../config/bop-wizard-config.json5'
import metadata from './ItemDetailsPage.metadata.json5';
import './ItemDetailsPage.messages';
import styles from './ItemDetailsPage.module.scss';
import { messages as commonMessages } from 'gw-platform-translations';
import { LoadSaveService } from 'gw-capability-gateway-quoteandbind';


function ItemDetailsPage(props) {
    const { steps } = wizardConfig;
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);
    const { wizardData, updateWizardData, authHeader, currentStepIndex, changeNextSteps} = props;
    const { submissionVM, selectedData } = wizardData;
    const { EndorsementService } = useDependencies('EndorsementService');
    const { 
        initialValidation,
        isComponentValid,
        registerComponentValidation 
    } = useValidation('ItemDetailsPage');

    const isDetailsComponentValid = useCallback(() => {
        return true;
    }, [submissionVM]);

    useEffect(() => {
        registerComponentValidation(isDetailsComponentValid);
    }, [registerComponentValidation, isDetailsComponentValid]);

    const onNext = useCallback(async () => {
        if(submissionVM.status.value.code === 'Draft'){
            submissionVM.value = await EndorsementService.quoteEndorsement(
                [submissionVM.jobID.value],
                authHeader
            );
        }
        return wizardData;
    }, [
        EndorsementService, 
        authHeader,
        currentStepIndex,
        changeNextSteps,
        selectedData,
        steps, 
        submissionVM, 
        wizardData
    ]);

    const handleError = useCallback(
        (title, message) => {
            return ModalNextProvider.showAlert({
                title: title,
                message: message,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok
            }).catch(_.noop);
        }, []
    );

    const submissionDocUploadToken = useCallback(async () => {
        try {
            const uploadTokenID = await LoadSaveService.submissionDocUploadToken([], authHeader);
            return uploadTokenID;
        } catch (e) {
            return handleError(
                commonMessages.errorUploadTitle,
                commonMessages.errorGenerateUploadToken
            );
        }
    }, [LoadSaveService, authHeader, handleError]);

    const onUploadDocument = useCallback(
        async (file) => {
            setShowLoader(true);
            const documentMetaDataTemplate = {
                DocUID: '001',
                DocumentType: 'fnol',
                SecurityType: 'unrestricted',
                Status: 'approved',
                Author: 'Policy Holder',
                jobID: submissionVM.jobID.value,
                name: file.name,
                mimeType: file.type,
                sessionID: await claimsDocUploadToken()
            };
            try {
                const data = await LoadSaveService.uploadDocument(
                    file,
                    documentMetaDataTemplate,
                    authHeader
                );
                const documentsArray = _.get(submissionVM, 'documents.value');
                documentsArray.push(data);
                const newSubmissionVM = _.clone(submissionVM);
                _.set(newSubmissionVM, 'documents.value', documentsArray);
                updateWizardData(newSubmissionVM);
                setShowLoader(false);
                /*var base64EncodedPDF = data.FileBase64Data;
                  var dataURI = "data:"+data.documentFile.contentType+";base64," + base64EncodedPDF;
                  window.open(dataURI, '_blank');*/
            } catch (error) {
                setShowLoader(false);
                handleError(commonMessages.errorUploadTitle, commonMessages.uploadFailedMessage);
            }
        },
        [submissionVM, submissionDocUploadToken, LoadSaveService, authHeader, updateWizardData, handleError]
    );

    const overrideProps =  {
        '@field': {
            labelPosition: 'left'
        },
    };

    const resolvers = {
        resolveCallbackMap: {
            onUploadDocument: onUploadDocument
        }
    };
   
    return (
        <WizardPage
            onNext={onNext}
            disableNext={!isComponentValid}
            skipWhen={initialValidation}
            cancelLabel={translator(appConfig.persona === 'policyholder' ? paymentMessages.cancelAllChanges : paymentMessages.cancel)}
            showPrevious
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                overrideProps={overrideProps}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={styles}
            />
        </WizardPage>
    );
}

ItemDetailsPage.propTypes = wizardProps;
export default withAuthenticationContext(ItemDetailsPage);
